module.exports = __webpack_public_path__ + "static/media/line_gris_claro.82245f77.jpg";